<template>
  <div>
    <p>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
      nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
      wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit
    </p>

    <div class="form-container--small">
      <label class="mt-4">
        Coupon Name
      </label>
      <b-form-input placeholder="Type here..." v-model="coupon.name"></b-form-input>

      <label class="mt-4-5">
        Coupon Code
      </label>
      <b-form-input placeholder="Type here..." v-model="coupon.code"></b-form-input>
    </div>
    <div class="form-container">
      <label class="mt-4-5">
        Coupon Description
      </label>
      <vue-editor v-model="coupon.description"></vue-editor>
    </div>

    <div class="form-container--small">
      <label class="mt-4-5">
        Coupon Type
      </label>
      <b-form-select
        v-model="coupon.type"
        :options="couponTypes"
      ></b-form-select>
      <b-input-group :append="coupon.type=='percentage' ? '%' : 'Rp'" class="mt-4">
        <b-form-input placeholder="Type here..." v-model="coupon.value"></b-form-input>
      </b-input-group>

      <label class="mt-4-5">
        Coupon Expire Date
      </label>
      <b-form-input placeholder="Pick a day" type="date" v-model="coupon.expired_date"></b-form-input>

      <!-- <label class="mt-4-5">
        Kupon Untuk
      </label>
      <b-form-select
        v-model="coupon.reference"
        :options="reference"
      ></b-form-select> -->

      <!-- <label class="mt-4-5">
        Pilih Produk
      </label>
      <b-form-select
        v-model="pilihProduct"
        :options="pilihProducts"
      ></b-form-select>

      <p class="mt-3">Produk yang dipilih:</p>

      <label class="mt-3">
        Pilih Kategori
      </label>
      <b-form-select v-model="category" :options="categories"></b-form-select>
      <p class="mt-3">Kategori yang dipilih:</p> -->

      <label class="mt-3">
        Jumlah Kupon
      </label>
      <b-form-input v-model="coupon.quantity"></b-form-input>

      <my-button type="blue" size="lg" class="mt-4-5" rounded block @click="save">
        SIMPAN KUPON
      </my-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
export default {
  data: () => ({
    options: [
      { text: 'User', value: 'user' },
      { text: 'Paket', value: 'subscribe' }
    ],
    couponTypes: [
      {
        text: "Price Discount",
        value: "price"
      },
      {
        text: "Percentage Discount",
        value: "percentage"
      }
    ],
    coupon: {
      description: "",
      type: "price",
      name:"",
      code:"",
      value: null,
      expired_date: null,
      quantity: null
    },
    reference: [
      {
        text: "User",
        value: "user"
      },
      {
        text: "Paket",
        value: "subscribe"
      },
      {
        text: "User dan Paket",
        value: "all"
      },
    ],
    productTypes: [
      {
        text: "--Select One--",
        value: ""
      },
      {
        text: "Product & Category",
        value: "Product & Category"
      }
    ],

    productType: "Product & Category",

    pilihProducts: [
      {
        text: "--Select One--",
        value: ""
      },
      {
        text: "Search product",
        value: "Search product"
      }
    ],

    pilihProduct: "Search product",

    categories: [
      {
        text: "--Select One--",
        value: ""
      },
      {
        text: "Search Category",
        value: "Search Category"
      }
    ],

    category: "Search Category"
  }),
  methods: {
    ...mapActions({
      setNewCoupon: types.SET_NEW_COUPON,
    }),
    save() {
      this.setNewCoupon(this.coupon)
      .then(response => {
        console.log(response);
        this.$router.push('/coupon/edit/'+response)
      }).catch(error => {
        this.showMessageBox(error, "Failed", "success");
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
        .msgBoxOk(message, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: variant,
          centered: true
        })
        .then(value => {
          this.temp = value;
        })
        .catch(err => {
          this.temp = err;
        });
    }
  }
};
</script>
